export const excludeToken = (
    tokenList: string[],
    tokens: NormalizedCardTokens,
    paymentMethodToExclude: PaymentMethodName,
) => {
    let newTokenList: string[] = [];
    tokenList.forEach((tokenId) => {
        const tokenObject = tokens.byId[tokenId];
        if (tokenObject.paymentMethod !== paymentMethodToExclude) {
            newTokenList = [...newTokenList, tokenObject.id];
        }
    });
    return newTokenList;
};
